export default __webpack_public_path__ + "static/media/lioness.eab8c8f9.webp";